import { render, staticRenderFns } from "./LanguageDropdown.vue?vue&type=template&id=2d12ad00"
import script from "./LanguageDropdown.vue?vue&type=script&lang=js"
export * from "./LanguageDropdown.vue?vue&type=script&lang=js"
import style0 from "./LanguageDropdown.vue?vue&type=style&index=0&id=2d12ad00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports